/* eslint-disable */
import Axios, { AxiosResponse } from "axios";
import { store } from "../redux/store";
const axios = Axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/`,
  // baseURL: `http://localhost:9005/`,
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return error.response || error;
  }
);

export function setToken(token: string | null) {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
}

function getHeaders(hasFormData = false) {
  const state = store.getState();
  const accessToken = state.auth.token;
  if (accessToken) {
    const headers: Record<string, string> = {
      Authorization: `Bearer ${accessToken}`,
      Accept: "application/json",
    };
    // Do NOT set Content-Type for FormData — the browser sets it automatically
    // with the correct multipart boundary. Setting it manually breaks file uploads.
    if (!hasFormData) {
      headers["Content-Type"] = "application/json";
    }
    return { headers };
  }
  return undefined;
}

const apiFunctions = {
  get: async (
    url: string,
    config: {
      params?: Record<string, any>;
      signal?: AbortSignal;
    } = {}
  ): Promise<AxiosResponse["data"]> => {
    return axios
      .get(url, {
        ...getHeaders(),
        params: config.params,
        signal: config.signal,
      })
      .then((res) => res)
      .catch((error) => error.response || error);
  },
  getById: async (url: string, id?: string): Promise<AxiosResponse["data"]> => {
    if (id != "" && id != null && id != undefined) {
      url = url + "/" + id;
    }
    return axios
      .get(url, getHeaders())
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error.response || error;
      });
  },
  post: async (
    url: string,
    data: object,
    id?: string | null,
    hasFormData = false,
  ): Promise<AxiosResponse["data"]> => {
    if (id != null && id != undefined && id != "") {
      url = url + "/" + id;
    }
    return axios
      .post(url, data, getHeaders(hasFormData))
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error.response || error;
      });
  },
  put: async (
    url: string,
    data: object,
    id?: string,
    hasFormData = false
  ): Promise<AxiosResponse["data"]> => {
    if (id != null && id != undefined && id != "") {
      url = url + "/" + id;
    }
    return axios
      .put(url, data, getHeaders(hasFormData))
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error.response || error;
      });
  },
  patch: async (
    url: string,
    data: object,
    id?: string
  ): Promise<AxiosResponse["data"]> => {
    if (id != null && id != undefined && id != "") {
      url = url + "/" + id;
    }
    return axios
      .patch(url, data, getHeaders())
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error.response || error;
      });
  },
  delete: async (url: string) => {
    return axios
      .delete(url, getHeaders())
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error.response || error;
      });
  },
};

// export default axios;
export default apiFunctions;
